import * as React from 'react'
import { useContext } from 'react'
import { InjectedIntl, injectIntl, IntlProvider } from 'react-intl'
import { createdDefaultMessages } from '../intl'

const intlProvider = new IntlProvider({ locale: 'en', defaultLocale: 'en' }, {})
const { intl } = intlProvider.getChildContext()

export const IntlContext = React.createContext<InjectedIntl>(intl as InjectedIntl)

export const InjectIntlContext = injectIntl(({ intl, children }) => {
  return <IntlContext.Provider value={intl}>{children}</IntlContext.Provider>
})

// the format message hook
export const useFormatMessage = () => {
  const intl = useContext(IntlContext)
  return intl.formatMessage
}

export const useFormatDate = () => {
  const intl = useContext(IntlContext)
  return intl.formatDate
}

export const useFormatNumber = () => {
  const intl = useContext(IntlContext)
  return intl.formatNumber
}

export const useFormatPlural = () => {
  const intl = useContext(IntlContext)
  return intl.formatPlural
}

export const useFormatRelative = () => {
  const intl = useContext(IntlContext)
  return intl.formatRelative
}

// Imperative methods
export const formatMessage = (message: string, values?: { [key: string]: ReactIntl.MessageValue }) => {
  return intl.formatMessage(createdDefaultMessages[message], values)
}

// export const formatDate = (...args: any[]) => {
//   cachedIntl.formatDate(...args)
// }
// export const formatNumber = cachedIntl.formatNumber
